var customGlobalObject;
(function($) {
  customGlobalObject = (function() {
    
    var self,
        customObject = function() {
          self = this;  
        },
        cOFn = customObject.prototype;
    
    cOFn.fn = cOFn;
    
    cOFn.months = {
      'short' : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      'full' : ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    };
    cOFn.desktopMin = parseFloat('1380px'.replace(/\D+/, ''));
    cOFn.desktopMax = parseFloat('1379px'.replace(/\D+/, ''));
    cOFn.smallDesktopMin = parseFloat('1024px'.replace(/\D+/, ''));
    cOFn.smallDesktopMax = parseFloat('1023px'.replace(/\D+/, ''));
    cOFn.tabletMin = parseFloat('700px'.replace(/\D+/, ''));
    cOFn.tabletMax = parseFloat('767px'.replace(/\D+/, ''));
    cOFn.mobileMin = parseFloat('480px'.replace(/\D+/, ''));
    cOFn.mobileMax = parseFloat('479px'.replace(/\D+/, ''));
    cOFn.window = $(window);
    cOFn.document = $('html');
    cOFn.body = $('body');
    
    cOFn.isUndefined = function(val) {
      return typeof val == 'undefined';
    }
    
    cOFn.isFunction = function(val) {
      return typeof val == 'function';
    }
          
    cOFn.handleSelectors = function(st) {
      return st.replace(/\./g, '');
    }

    cOFn.hasOwnProperty = function(data, prop) {
      if(!Array.isArray(prop)) {
        return data.hasOwnProperty(prop);
      }
      let _hasOwnProperty = false;
      prop.forEach((item) => {
        _hasOwnProperty = data.hasOwnProperty(item);
      });
      return _hasOwnProperty;
    }

    cOFn.isJSONString = function(str) {
      let _isJSONString = false;
      try {
        _isJSONString = JSON.parse(str);
      } catch(e) {
        return _isJSONString;
      }
      return _isJSONString;
    }

    cOFn.jsonp_custom = function(url, callback) {

      function removeCallback(callbackName){

        delete window[callbackName];
        document.body.removeChild(script);

      }

      var callbackName = 'jsonp_callback_' + Math.round(100000 * Math.random());

      window[callbackName] = function(data) {

        removeCallback(callbackName);
        callback(data);			

      }

      var script = document.createElement('script');
      script.src = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'c=' + callbackName;

      script.onerror = function(){

        removeCallback(callbackName);
        callback('An error occured while processing the request.');

      }

      document.body.appendChild(script);

    }

    cOFn.handleIntervals = {
      "requestInterval": function(fn, delay) {
        const requestAnimFrame = (function() {
          return window.requestAnimationFrame || function(callback, element) {
            window.setTimeout(callback, 1000 / 60);
          };
        })();
    
        let start = new Date().getTime(),
            handle = {};
    
        function loop() {
          const current = new Date().getTime(),
            delta = current - start;
    
          if (delta >= delay) {
            fn.call();
            start = new Date().getTime();
          }
    
          handle.value = requestAnimFrame(loop);
        }
    
        handle.value = requestAnimFrame(loop);
        return handle;
      },
      "clearRequestInterval": function(handle) {
        window.cancelAnimationFrame ? window.cancelAnimationFrame(handle.value) :
          clearInterval(handle);
      }
    }

    cOFn.requestInterval = function(type, fn, interval) {
      
      return self.handleIntervals.requestInterval(fn, interval);
      
    }

    cOFn.clearRequestInterval = function(handle) {
      
      self.handleIntervals.clearRequestInterval(handle);
      
    }
          
    cOFn.handleScroll = function(elm, callback) {

      if(!elm.length) return;

      $('html, body').stop().animate({scrollTop: elm.offset().top}, 450, () => {
        if(!self.isFunction(callback)) return;
        callback.call();
      });

    }
    
    cOFn.handleInfiniteScroll = function(container, elm, callback) {

      if(!self.isFunction(callback)) return self;

      let isWindow = 1,
          pageOffsetTopCustom = 'pageYOffset',
          offsetTopCustom = 'offsetTop',
          innerHeightCustom = 'innerHeight' in window ? 'innerHeight' : 'clientHeight';

      if(container != window) {

        isWindow = 0;
        pageOffsetTopCustom = 'scrollTop';
        offsetTopCustom = 'offsetTop';
        innerHeightCustom = 'offsetHeight';

      }

      container.addEventListener('scroll', function() {

        let innerHeightCustomDefined = (!isWindow ? container[offsetTopCustom] : 0) + container[innerHeightCustom];

        if(container[pageOffsetTopCustom] + innerHeightCustomDefined >= elm[offsetTopCustom]) {
          callback(container, elm, container[pageOffsetTopCustom], innerHeightCustomDefined, elm[offsetTopCustom]);
        }

      });

      return self;

    }
    
    cOFn.handleGeneralChanges = function() {

      (() => {

        let cssSliders = document.querySelectorAll('.css-slider');

        if(!cssSliders.length) return;

        for(let cssSlider of cssSliders) {

          cssSlider.addEventListener('ready', (slider) => {

            if(self.isUndefined(slider.target) || !slider.target.hasAttribute('data-options')) return;

            let _slider = slider.target,
                sliderDataOptions = _slider.getAttribute('data-options'),
                sliderDataOptionsParsed = self.isJSONString(sliderDataOptions),
                sliderInterval = 5,
                hoverActive = false;

            if(!sliderDataOptionsParsed || !self.hasOwnProperty(sliderDataOptionsParsed, ['autoplay', 'interval', 'progressBarHandle']) || !sliderDataOptionsParsed.autoplay) return;

            let sliderDataOptionsIntervalParsed = parseInt(sliderDataOptionsParsed.interval),
                _sliderNavDots = _slider.querySelectorAll('.css-slider-dot'),
                _sliderElement = _slider.querySelector('.css-slider-holder'),
                _sliderProgressBarEnabled = false,
                _sliderProgressBar,
                progressBarInner,
                progressBarInitialHeight = '0px';
            
            if(sliderDataOptionsParsed.progressBarHandle.trim() != '') {
                _sliderProgressBarEnabled = true;
                _sliderProgressBar = document.querySelector(sliderDataOptionsParsed.progressBarHandle);
                progressBarInner = $(sliderDataOptionsParsed.progressBarHandle + ' [data-progress-bar]');
                progressBarInitialHeight = progressBarInner.css('height');
            }
            
            sliderInterval = (isNaN(sliderDataOptionsIntervalParsed) || sliderDataOptionsIntervalParsed < 2 ? sliderInterval : sliderDataOptionsIntervalParsed) * 1000;

            // Needed an override to make the drag functionality work when the slider reached either the first or last slide, it did not work previously
            _slider.changeSlide = function(direction, behavior='smooth') {
              if(direction == 'next') {
                _slider.index = _slider.index + 1 < _slider.length ? _slider.index + 1 : 0;
              } else if(direction == 'prev') {
                _slider.index = _slider.index - 1 >= 0 ? _slider.index - 1 : _slider.length - 1;
              } else if(parseInt(direction) >= 0) {
                _slider.index = parseInt(direction);
              }
        
              _slider._sliderBlockScroll = true;
              setTimeout(() => {
                _slider._sliderBlockScroll = false;
              }, 500);  
              
              _slider.checkSlide();
              _sliderElement.scrollTo({
                top: 0,
                left: _slider._rtl && _slider.slidesPerPage > 1 ? (_slider.querySelector('.css-slider-container').offsetWidth - (_slider.indexedItems[_slider.index].offsetLeft - parseInt(getComputedStyle(_slider.indexedItems[0]).marginLeft))) * -1 : _slider.indexedItems[_slider.index].offsetLeft - parseInt(getComputedStyle(_slider.indexedItems[0]).marginLeft),
                behavior: behavior
              });
              _slider.dispatchEvent(_slider._changeEvent);
            }

            function animateProgressBar() {
              if(!_sliderProgressBarEnabled) return;
              progressBarInner.css('height', progressBarInitialHeight);
              progressBarInner.animate({
                width: "100%", 
              }, sliderInterval);
            }

            function resetProgressBar() {
              if(!_sliderProgressBarEnabled) return;
              progressBarInner.stop();
              progressBarInner.css('width', '0px');
              //progressBarInner.css('height', '0px');
            }
            
            function startSlider() {
              animateProgressBar();
              return self.requestInterval(_slider, () => {
                let sliderStep = _slider.index + 1 >= _slider.length ? 0 : 'next';
                _slider.changeSlide(sliderStep);
              }, sliderInterval);
            }
            function endSlider(interval) {
              self.clearRequestInterval(interval);
            }

            let intervalId = startSlider();

            ['mouseenter', 'touchstart'].forEach((item) => {
            
              _slider.addEventListener(item, (evt) => {
  
                endSlider(intervalId);
                resetProgressBar();
  
                hoverActive = true;
                
              });
              
            });

            _slider.addEventListener('mouseleave', (evt) => {

              intervalId = startSlider();

              hoverActive = false;
              
            });

            _slider.addEventListener('change', (evt) => {
              
              resetProgressBar();
              if(!hoverActive) animateProgressBar();
              
            });
            
          });
          
        }
        
      })();

      (() => {

        let tabsCustom = $('.mp-es-tab-custom'),
            tabsContentCustom = $('.mp-es-tab-content-custom');

        if(!tabsCustom.length || !tabsContentCustom.length || tabsCustom.length != tabsContentCustom.length) return;

        let customAttr_1 = 'data-tab-handle-custom',
            customAttr_2 = 'data-tab-content-custom';

        tabsCustom.each((index, item) => {

          let _item = $(item);
        
          _item.click((e) => {
  
            e.preventDefault();
            
            let _thisHandle = $('[' + customAttr_2 + '="' + _item.attr(customAttr_1) + '"]');
            
            if(!_thisHandle.length) return;

            tabsCustom.removeClass('active');
            _item.addClass('active');

            tabsContentCustom.removeClass('active');
            _thisHandle.addClass('active');
            
          });
          
        });
        
      })();
      
      return self;
      
    }  

    cOFn.handleProductPageChanges = function() {

      if(!$('.template-product').length) return;

      (() => {

        let reviewsMainBadge = document.querySelector('.mp-reviews-badge-wrapper-custom'),
            reviewsTab = document.querySelector('[data-tab-handle-custom="reviews"]');

        if(reviewsMainBadge == null || reviewsTab == null) return;

        let reviewsTabJQ = $(reviewsTab);

        reviewsMainBadge.addEventListener('click', () => {
          reviewsTabJQ.trigger('click');
          self.handleScroll(reviewsTabJQ);
        }, true);
        
      })();
      
      return self;
      
    }  
    
    
    
    return new customObject()
                  .handleGeneralChanges()
                  .handleProductPageChanges();
    
  })();
})(jQuery);